import { useContext } from "react";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  getDashboardConfig,
  saveDashboardConfig,
} from "../api/dashboardConfig";
import { DashboardWidget } from "../types/dashboard/DashboardConfig";
import { AuthContext } from "../context/AuthContext";

const QUERY_KEY = "dashboard-config";

export const useDashboardConfig = (customerId: string | undefined) => {
  const { user } = useContext(AuthContext);
  const userId = user?.userId;

  return useQuery({
    queryKey: [QUERY_KEY, customerId, userId],
    queryFn: () => getDashboardConfig(customerId!),
    enabled: !!customerId && !!userId,
  });
};

export const useSaveDashboardConfig = (customerId: string | undefined) => {
  const { user } = useContext(AuthContext);
  const userId = user?.userId;
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (widgets: DashboardWidget[]) =>
      saveDashboardConfig(customerId!, widgets),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEY, customerId, userId] });
    },
  });
};

export const useInvalidateDashboardConfig = () => {
  const queryClient = useQueryClient();
  return (customerId: string) => {
    queryClient.invalidateQueries({ queryKey: [QUERY_KEY, customerId] });
  };
};
